import axios from 'axios'

/** Extract DRF-style `detail` from an axios error, falling back to `fallback`. */
export function getApiErrorDetail(err: unknown, fallback: string): string {
  if (!axios.isAxiosError(err)) {
    return fallback
  }
  const detail = err.response?.data?.detail
  return typeof detail === 'string' && detail.length > 0 ? detail : fallback
}
